import { render } from "./Form.vue?vue&type=template&id=2d3348da&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=2d3348da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d3348da"

export default script